<ui-modal-full
  title="Charge guest from deposit"
  (backClicked)="close()"
  (closeClicked)="close()"
  [primaryAction]="primaryAction"
  [secondaryAction]="secondaryAction">
  <form [formGroup]="form" class="grid gap-6">
    <h2 class="m-0">Tell us what happened and how much you want to charge from the deposit</h2>

    <div class="grid border border-gray-200 rounded-xl py-5 px-4">
      <div class="grid grid-cols-[auto_1fr] gap-x-1 gap-y-2">
        <span class="text-sm text-smoke-darker">Reservation:</span>
        <span class="text-sm">
          {{ reservation.code }}, {{ reservation.guest }}, {{ reservation.start_date | date: 'MMM d' }} -
          {{ reservation.end_date | date: 'MMM d' }}
        </span>
        <span class="text-sm text-smoke-darker">Deposit:</span>
        <span class="text-sm">
          {{ reservation.security_deposit.amount.formatted_string }} held, {{ daysUntilRelease }} days left to submit a
          charge
        </span>
      </div>
    </div>

    <div class="grid gap-1">
      <h3>Charge amount</h3>
      <span class="text-sm"
        >You can charge up to the {{ reservation.security_deposit.amount.formatted_string }} deposit.</span
      >
      <mat-form-field>
        <span matPrefix class="prefix-bg">
          <span class="text__small" style="padding-right: 12px">{{ reservation.currency | currencyCode }}</span>
        </span>
        <input matInput formControlName="amount" type="number" />
        <mat-error *ngIf="form.controls.amount.errors?.required">Please enter an amount</mat-error>
        <mat-error *ngIf="form.controls.amount.errors?.min || form.controls.amount.errors?.max">
          The amount must be between {{ reservation.currency | currencyCode }}1.00 and the full deposit amount of
          {{ reservation.security_deposit.amount.formatted_string }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="grid gap-1">
      <h3>Incident type</h3>
      <mat-form-field>
        <mat-select formControlName="type">
          <mat-option value="accidental_damage">Accidental Damage</mat-option>
          <mat-option value="missing_or_stolen_items">Missing or stolen items</mat-option>
          <mat-option value="malicious_damage">Malicious damage</mat-option>
        </mat-select>
        <mat-error *ngIf="form.controls.type?.errors?.required"> Please select an incident type </mat-error>
      </mat-form-field>
    </div>

    <div class="grid gap-1">
      <h3>Incident description</h3>
      <sbnb-textarea
        [minRows]="4"
        placeholder="What was damaged or broken?"
        formControlName="description"></sbnb-textarea>
      <mat-error
        *ngIf="
          form.controls.description?.errors?.required &&
          (form.controls.description.touched || form.controls.description.dirty)
        ">
        Please enter a description
      </mat-error>
    </div>

    <div class="grid gap-1">
      <h3>Upload evidence</h3>
      <span class="text-sm"
        >Examples include time-stamped photos of damage, repair receipts, and relevant messages with the guest. (max
        10MB, JPG/PNG/PDF)</span
      >
      <sbnb-upload-assets
        [assetType]="'image'"
        [thumbnails]="form.controls.images.value"
        [options]="{
          maxFiles: 30,
          fromSources: ['local_file_system', 'url'],
          accept: ['image/jpeg', 'image/png', 'application/pdf']
        }"
        (uploadSuccess)="imageUploadSuccess($event)"
        (remove)="imageRemoved($event)"></sbnb-upload-assets>
      <mat-error
        *ngIf="form.controls.images.errors?.required && (form.controls.images.touched || form.controls.images.dirty)"
        >Please upload evidence</mat-error
      >
    </div>

    <div class="grid border border-gray-200 rounded-xl py-5 px-4 gap-1">
      <mat-checkbox formControlName="userConfirmation">
        I confirm these details accurately reflect damages or charges from this reservation.
      </mat-checkbox>
      <mat-error
        *ngIf="
          form.controls.userConfirmation.errors?.required &&
          (form.controls.userConfirmation.touched || form.controls.userConfirmation.dirty)
        ">
        Please confirm the details
      </mat-error>
    </div>
  </form>
</ui-modal-full>
